import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Home from "@/views/Home.vue";
import JobFairDetail from "@/views/JobFairDetail.vue";
import OrganizerDashboard from "@/views/OrganizerDashboard.vue";
import CompanyDetail from "@/views/CompanyDetail.vue";
import CompanyDashboard from "@/views/CompanyDashboard.vue";
import EventActivityStats from "@/views/EventActivityStats.vue";
import Unauthenticated from "@/views/Unauthenticated.vue";
import NotFound from "@/views/NotFound.vue";
import CompanyRegister from "@/views/CompanyRegister.vue";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/not-found",
    name: "not-found",
    component: NotFound,
  },
  {
    path: "/:slug",
    name: "job-fair-detail",
    component: JobFairDetail,
  },
  {
    path: "/organizer/dashboard/:slug",
    name: "school-dashboard",
    component: OrganizerDashboard,
  },
  {
    path: "/:slug/dashboard/event-stats",
    name: "school-dashboard-event-stats",
    component: EventActivityStats,
  },
  {
    path: "/:slug/not-found",
    name: "not-found-with-job-fair",
    component: NotFound,
  },
  {
    path: "/company/:slug/:company_slug",
    name: "company-detail",
    component: CompanyDetail,
  },
  {
    path: "/company/dashboard/:slug/:company_slug",
    name: "company-dashboard",
    component: CompanyDashboard,
  },
  {
    path: "/:slug/company/register",
    name: "company-register",
    component: CompanyRegister,
  },
  {
    path: "/unauthenticated/:actor/:slug",
    name: "unauthenticated",
    component: Unauthenticated,
  },
  {
    path: "/organizer/unauthenticated/:slug",
    name: "unauthenticated-organizer",
    component: Unauthenticated,
  },
  {
    path: "*",
    component: NotFound,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: () => {
    return {
      x: 0,
      y: 0,
    };
  },
  routes,
});

export default router;
